/* Line clamp for Baby le Bebe — used by blocks/found-in.liquid and
   sections/botanical-profiles.liquid. Collapses a block of text to a fixed
   number of lines and adds a click-to-expand control when it overflows. */
(function () {
  if (window.__blbClampInit) return;
  window.__blbClampInit = true;

  var records = [];

  function lineHeight(el) {
    var cs = getComputedStyle(el);
    var lh = parseFloat(cs.lineHeight);
    if (!lh || isNaN(lh)) lh = parseFloat(cs.fontSize) * 1.6;
    return lh;
  }

  function collapse(rec) {
    rec.el.classList.add('is-clamped');
    rec.el.style.maxHeight = Math.round(lineHeight(rec.el) * rec.lines) + 'px';
  }

  function expand(rec) {
    rec.el.classList.remove('is-clamped');
    rec.el.style.removeProperty('max-height');
  }

  function apply(el) {
    if (!el || el.dataset.clampReady === 'true') return;
    var lines = parseInt(el.dataset.clamp, 10);
    if (!lines || lines < 1) return;

    el.dataset.clampReady = 'true';
    el.style.setProperty('--clamp-lines', lines);

    var rec = { el: el, lines: lines, open: false };
    collapse(rec);

    if (el.scrollHeight <= el.clientHeight + 2) {
      expand(rec);
      return;
    }

    var more = el.dataset.clampMore || '…';
    var less = el.dataset.clampLess || 'Show less';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'clamp-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = more;
    btn.addEventListener('click', function () {
      rec.open = !rec.open;
      if (rec.open) { expand(rec); } else { collapse(rec); }
      btn.setAttribute('aria-expanded', rec.open ? 'true' : 'false');
      btn.textContent = rec.open ? less : more;
    });
    // Keep the text and its control together as one flex item, otherwise the
    // card's own row gap pushes the control away from the text it belongs to.
    var probe = el.firstElementChild || el;
    var wrap = document.createElement('div');
    wrap.className = 'clamp-group';
    wrap.style.width = '100%';
    wrap.style.alignSelf = 'stretch';
    wrap.style.textAlign = getComputedStyle(probe).textAlign;
    el.parentNode.insertBefore(wrap, el);
    wrap.appendChild(el);
    wrap.appendChild(btn);

    rec.button = btn;
    rec.wrap = wrap;
    records.push(rec);
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var markers = scope.querySelectorAll('.found-in[data-clamp-prev]');
    for (var i = 0; i < markers.length; i++) {
      var m = markers[i];
      var target = m.previousElementSibling;
      if (!target) continue;
      target.setAttribute('data-clamp', m.getAttribute('data-clamp-prev'));
      if (m.getAttribute('data-clamp-more')) target.setAttribute('data-clamp-more', m.getAttribute('data-clamp-more'));
      if (m.getAttribute('data-clamp-less')) target.setAttribute('data-clamp-less', m.getAttribute('data-clamp-less'));
    }
    var targets = scope.querySelectorAll('[data-clamp]');
    for (var j = 0; j < targets.length; j++) apply(targets[j]);

    // "plus N more" reveals the rest of a Found in list.
    var toggles = scope.querySelectorAll('.found-in__toggle');
    for (var k = 0; k < toggles.length; k++) {
      (function (btn) {
        if (btn.dataset.foundInReady === 'true') return;
        btn.dataset.foundInReady = 'true';
        btn.addEventListener('click', function () {
          var root = btn.closest('.found-in');
          if (!root) return;
          var rest = root.querySelector('.found-in__extra');
          if (rest) rest.hidden = false;
          var wrap = btn.closest('.found-in__morewrap');
          if (wrap) wrap.hidden = true;
          btn.setAttribute('aria-expanded', 'true');
        });
      })(toggles[k]);
    }
  }

  function boot() {
    scan(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { scan(document); });
    }
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      for (var i = 0; i < records.length; i++) {
        if (!records[i].open) collapse(records[i]);
      }
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
